<template>
  <div class="container">
    <CRow class="justify-content-center mt-4">
      <CCol cols="12" xs="12" sm="12" md="6" xl="4" v-for="each in dataSystem" :key="each.id">
        <div class="card text-center">
          <div class="card-body">
            <h5 class="card-title">{{ each.name }}</h5>
            <!--            <h6 class="card-subtitle mb-2 text-muted">Card subtitle</h6>-->
            <p class="card-text">{{ each.description }}</p>
            <button class="btn btn-primary" @click="clickRedirectSystem(each.url, each.clientId)">Tiến vào <i
              class="fa fa-arrow-right"></i></button>
          </div>
        </div>
      </CCol>
      <BaseFormLoading :loading="loading.value"></BaseFormLoading>
    </CRow>
  </div>
</template>

<script>
import {getUserId} from '@/security/index'
import {ACCESS_TOKEN_EXPIRED, ACCESS_TOKEN_NAME, LOCATION_CODE, REDIRECT_URI_NAME} from "@/constant";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import helpers from "@/helper";

export default {
  name: 'Dashboard',
  components: {BaseFormLoading},
  data() {
    return {
      loading: {
        value: false
      },
      dataSystem: []
    }
  },
  methods: {
    loadData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/system/listSystemDashboard",
        isJsonContentType: false,
        dataSubmit: function () {
          return {userId: getUserId()}
        },
        successCallback: function (response) {
          that.dataSystem = response.data.data;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    clickRedirectSystem(redirectUri, clientId) {
      if (clientId && redirectUri) {
        let that = this;
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/oauth/authorization-code",
          isJsonContentType: false,
          dataSubmit: function () {
            return {
              client_id: clientId
            }
          },
          successCallback: function (response) {
            if (response.data.returnCode === 1) {
              let code = response.data.data;
              window.location.href = `${redirectUri}?code=${code}`
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      }
    }
  },
  created() {
  }
  ,
  computed: {}
  ,
  mounted() {
    this.loadData();
  }
  ,
}
</script>

<style scoped>
.card-body:hover {
  box-shadow: 0px 2px 20px 0px rgb(0 0 0 / 16%), 0 10px 10px rgb(0 0 0 / 14%);
}
</style>
